module.exports = __webpack_public_path__ + "static/gallery-13-1286f27cc2f4d3bc394c726e6b0b03ea.jpg";